import React, { useState, useMemo } from 'react';
import { Button, Table } from 'tea-component';
import { useIntl, history, getLocale } from 'umi';
import '@/pages/intelligence/assets/scss/Following/manage.scss';
import FirstRow from '@/pages/intelligence/components/TableComponents/components/FirstRow';
import FollowMultipleChoice from '@/pages/intelligence/pages/Following/components/FollowMultipleChoice';
import { getCountryFlag } from '@/pages/home/_config/countries';
import SelectGroup from '@/pages/intelligence/pages/Following/Manage/SelectGroup';
import { GenreRender } from '@/pages/intelligence/components/TableComponents/components/TableGenre';
import useCountriesNames from '@intelligence/hooks/useCountriesNames';
import { getDetailGameOverviewPath } from '@/pages/intelligence/utils/topchartsUtils';
import moment from 'moment';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import { PAGE_SIZES_SMALL } from '@intelligence/utils/tableUtils';
const { sortable, pageable } = Table.addons;

const SubTable = (porps: any) => {
  const {
    gameList,
    setCheckListPa,
    total,
    groupList,
    groupName,
    setLoading,
    mainSegment,
    setGroup,
    handleChangeSeg,
    checkList = [],
    setCheckList,
    // checkAllGamesList = [],
    // setCheckAllGamesList,
    checkTrueGameIds,
    setCheckTrueGameIds,
    getPageDatas,
    OnUnfollow,
    regionsCountries,
    DEFAULT_GROUPNAME,
    MYFAVOURITE,
    group,
    pagingQuery,
    onPagingChange,
    sort: sortProps = [],
    onSortChange,
  } = porps;

  // console.log('SubTableSubTableSubTable', porps);
  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const isCN = locale === LANGUAGE_CN;
  // const [sorts, setSorts] = useState<any>([]);
  const [sorts, setSorts] = useState<any[]>(sortProps);

  const { findCountryObj } = useCountriesNames();

  const speStr = useMemo(() => {
    return groupName?.replace(/\s*/g, '');
  }, [groupName]);

  const getGameInfo = (data: any) => {
    const isCompany = mainSegment == 'company';
    const companyCountryCode =
      findCountryObj(data?.location_identifiers_country)?.code || data?.publisher_addr;
    const imgUrl = mainSegment == 'company' ? companyCountryCode : data?.publisher_addr;
    return {
      // gametitle: data.name,
      // img: isCompany ? data?.cover ? data?.cover: data.image_url : data.cover,
      // text: data.publisher,
      // imgType: mainSegment,
      // countryIcon: mainSegment == 'company' ? (data?.publisher_addr? getCountryFlag(data?.publisher_addr?.toLowerCase()) : getCountryFlag(getCountryCodeByCountryName(regionsCountries, imgUrl, true))) : getCountryFlag(imgUrl?.toLocaleUpperCase()),

      gametitle: data?.name,
      img: isCompany ? data?.image_url || data?.cover : data?.cover,
      text:
        mainSegment == 'company'
          ? `${data.location_identifiers_city} ${data.location_identifiers_country}`
          : data?.publisher,
      imgType: mainSegment,
      countryIcon: getCountryFlag(data?.publisher_addr || data?.location_identifiers_country_code),
    };
  };

  const getGameCheckHandle = (val: string, game: any, gameTrue?: any) => {
    // 勾选游戏后，清空勾选分组，两者不能混合
    setCheckListPa && setCheckListPa([]);

    const listTemp: any = checkList;
    // let listAllGamesTemp: any = checkAllGamesList;
    const listTrueTemp: any = checkTrueGameIds;
    let list: any = [];
    let listTrue: any = [];

    if (game == speStr) {
      // if (groupName == DEFAULT_GROUPNAME) {
      //   setCheckAllGamesList && setCheckAllGamesList(
      //     val ? (gameList?.map((item: any) => (item.app_id + speStr)) || [])
      //       : []
      //   );
      // }
      // setCheckList && setCheckList(
      //   val ? (gameList?.map((item: any) => (item.app_id + speStr)) || [])
      //     : []
      // );
      // setCheckTrueGameIds && setCheckTrueGameIds(
      //   val ? (gameList?.map((item: any) => (item.app_id)) || [])
      //     : []
      // );
      const gameIds: string[] =
        (group ? group?.group_game_ids : gameList?.map((item: any) => item?.app_id)) || [];
      const speStrGameIds = gameIds?.map((gameId) => gameId + speStr);
      setCheckList?.(!val ? [] : speStrGameIds);
      setCheckTrueGameIds?.(!val ? [] : gameIds);
    } else {
      if (Array.isArray(listTemp) && Array.isArray(listTrueTemp)) {
        if (val) {
          if (!listTemp?.includes(game)) {
            listTemp?.push(game);
          }
          for (const n in listTemp) {
            list?.push(listTemp[n]);
          }
          if (!listTrueTemp?.includes(gameTrue)) {
            listTrueTemp?.push(gameTrue);
          }
          for (const n in listTrueTemp) {
            listTrue?.push(listTrueTemp[n]);
          }

          // if (groupName == DEFAULT_GROUPNAME) {
          //   if (!listAllGamesTemp?.includes(game)) {
          //     listAllGamesTemp?.push(game);
          //   }
          //   for (let n in listAllGamesTemp) {
          //     list?.push(listAllGamesTemp[n]);
          //   }
          // }
        } else {
          list = listTemp?.filter((item: any) => item != game);
          listTrue = listTrueTemp?.filter((item: any) => item != game);
          // if (groupName == DEFAULT_GROUPNAME) {
          //   list = listAllGamesTemp?.filter((item: any) => item != game);
          // }
        }
      }
      setCheckList && setCheckList(list);
      setCheckTrueGameIds && setCheckTrueGameIds(listTrue);
      // if (groupName == DEFAULT_GROUPNAME) {
      //   setCheckAllGamesList && setCheckAllGamesList(list);
      // }
    }
  };

  const onUnfollowHandle = (item: any) => {
    setCheckTrueGameIds([item.app_id]);
    OnUnfollow();
  };

  const onClickGame = (gameId: string) => {
    history.push(getDetailGameOverviewPath(gameId, mainSegment));
  };

  return (
    <Table
      // records={[...gameList].sort(sortable.comparer(sorts))}
      records={gameList}
      recordKey="id"
      columns={[
        {
          key: 'allgames',
          header: (
            <FollowMultipleChoice
              checkList={checkList}
              groupList={gameList}
              DEFAULT_GROUPNAME={DEFAULT_GROUPNAME}
              name={speStr}
              isAll={true}
              isSubTableAll={true}
              onChange={(value: any) => {
                getGameCheckHandle(value, speStr);
              }}
            />
          ),
          width: 37,
          fixed: 'left',
          render: (cvm) => (
            <FollowMultipleChoice
              checkList={checkList}
              DEFAULT_GROUPNAME={DEFAULT_GROUPNAME}
              groupList={gameList}
              name={cvm.app_id + speStr}
              onChange={(value: any) => {
                getGameCheckHandle(value, cvm.app_id + speStr, cvm.app_id);
              }}
            />
          ),
        },
        {
          key: 'title',
          header: formatMessage({
            id: mainSegment === 'company' ? 'dbi_company_companies' : 'dbi_game',
          }),
          width: 300,
          fixed: 'left',
          render: (cvm: any) => {
            return (
              <FirstRow
                cvm={getGameInfo(cvm)}
                rihgtClickToJumpHref={getDetailGameOverviewPath(cvm?.app_id, mainSegment)}
                onClick={() => {
                  onClickGame(cvm?.app_id);
                }}
              />
            );
          },
        },
        {
          key: 'main_genre',
          width: 300,
          header: formatMessage({ id: 'dbi_label_genre' }),
          render: (cvm: any) => (
            <GenreRender mainGenre={cvm?.genre || '-'} subGenre={cvm?.sub_genre || '-'} />
          ),
        },
        {
          key: 'release_time',
          width: 150,
          header: formatMessage({ id: 'dbi_release_date' }),
          render: (cvm) => <>{isCN ? cvm?.release_time_cn : cvm?.release_time_en || '-'}</>,
        },
        {
          key: 'following_time',
          header: formatMessage({ id: 'dbi_subscription_date' }),
          width: isCN ? 150 : 200,
          render: (cvm) => <>{moment(cvm?.following_time).format('YYYY-MM-DD') || '-'}</>,
        },
        {
          key: '',
          header: formatMessage({ id: 'dbi_actions' }),
          width: 230,
          render: (cvm) => (
            <div className="table-btn-flex">
              <SelectGroup
                cvm={cvm}
                groupList={groupList}
                groupName={groupName}
                setLoading={setLoading}
                mainSegment={mainSegment}
                setGroup={setGroup}
                gameIds={checkTrueGameIds}
                handleChangeSeg={handleChangeSeg}
                setCheckList={setCheckList}
                setCheckTrueGameIds={setCheckTrueGameIds}
                isSubOptions={true}
                MYFAVOURITE={MYFAVOURITE}
                DEFAULT_GROUPNAME={DEFAULT_GROUPNAME}
              />
              <Button
                type="link"
                onClick={() => {
                  onUnfollowHandle(cvm);
                }}
                className="dbi-following-manage-unfollow"
              >
                {formatMessage({ id: 'dbh_unfollow' })}
              </Button>
              {/* {
                groupName != DEFAULT_GROUPNAME && <Button
                  type="link"
                  onClick={() => {
                    moveOutHandle(cvm);
                  }}
                >
                  Move out
                </Button>
              } */}
            </div>
          ),
        },
      ]}
      addons={[
        pageable({
          pageSizeOptions: PAGE_SIZES_SMALL,
          pageSizeVisible: true,
          stateText: formatMessage({ id: 'dbi_pagination_total' }, { total: total ?? 0 }),
          isPagingReset: true,
          recordCount: pagingQuery?.total,
          pageIndex: pagingQuery?.pageIndex || 1,
          pageSize: pagingQuery?.pageSize || PAGE_SIZES_SMALL[0],
          onPagingChange,
        }),
        sortable({
          columns: ['following_time'],
          value: sorts,
          // onChange: (value) => setSorts(value),
          onChange: (value) => {
            setSorts(value);
            onSortChange?.(value);
          },
        }),
      ]}
    />
  );
};

export default SubTable;
